import { render, staticRenderFns } from "./Additional.vue?vue&type=template&id=fac39194&"
import script from "./Additional.vue?vue&type=script&lang=js&"
export * from "./Additional.vue?vue&type=script&lang=js&"
import style0 from "./Additional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports